/* eslint-disable no-shadow */
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { compareStringWithAccent } from 'utils/string'
import SimpleDropdown, { SelectButton } from 'components/Select/Simple'
import MapPinIcon from 'components/Icons/MapPinIcon'
import { isMobile } from 'react-device-detect'

import {
  Section,
  SectionHeader,
} from './PartnerServiceOffer.style'

import Carousel from './carousel'
import mapServiceCard from './carouselItem'

const getVillageList = (serviceList, allVillages) => {
  const uniqueList = []
  serviceList.forEach(({ villageList }) => {
    if(villageList?.length > 0) {
      villageList.forEach(village => {
        const villageData = allVillages.find(({ name }) => compareStringWithAccent(village, name))
        if(
          !uniqueList.some(({ name }) => String(village).includes(name))
          && villageData
        ) {
          uniqueList.push(villageData)
        }
      })
    }
  })

  return uniqueList
}

const PartnerServiceOffer = (props) => {
  const { title, items, labels, villageName = 'Bicester Village', allVillages } = props
  const villageData = allVillages?.edges?.map(({ node }) => node).filter(({ name }) => !/Shangai|Suzhou/gi.test(name)) ?? []
  const defaultVillage = villageData.find(({ name }) => compareStringWithAccent(name, villageName))
  
  const [selectedVillage, setSelectedVillage] = useState(defaultVillage)
  const villageList = getVillageList(items, villageData)

  const {
    edges: [{
      node: {
        bookLabel,
        villageSelectLabel,
        villageSelectPlaceholder
      }
    }]
  } = labels

  const availableItems = selectedVillage
    ? items.filter(({ villageList }) => villageList?.some((village) => compareStringWithAccent(selectedVillage.name, village)))
    : items

  return (
    <Section>
      <SectionHeader>
        {title}
      </SectionHeader>
      <SimpleDropdown
        data={villageList}
        label={
          <>
            {`${villageSelectLabel ?? 'Your village'}: `}
            {`${selectedVillage.name}${selectedVillage?.city ? `, ${selectedVillage?.city}` : ''}`}
          </>
        }
        icon={<MapPinIcon width={isMobile ? '14px' : '20px'} />}
        placeholder={villageSelectPlaceholder ?? 'Select other village'}
        minWidth={423}
        renderItem={({ itemData, closeDropdown }) => (
          <SelectButton onClick={() => {
            setSelectedVillage(itemData)
            closeDropdown()
          }}>
            <span>
              <strong>{itemData.name}</strong>
              {itemData?.city && `, ${itemData.city}`}
            </span>
          </SelectButton>
        )}
      />
      <Carousel
        data={availableItems}
        bookLabel={bookLabel}
        village={selectedVillage.name}
        mapServiceCard={mapServiceCard}
      />
    </Section>
  )
}

PartnerServiceOffer.propTypes = {
  title: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.string]),
  labels: PropTypes.shape({ edges: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])) }),
  allVillages: PropTypes.shape({ edges: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])) }),
  villageName: PropTypes.string
}

PartnerServiceOffer.defaultProps = {
  title: '',
  items: [],
  labels: [],
  allVillages: { edges: [{ node: null }] },
  villageName: PropTypes.string
}

export default PartnerServiceOffer
